import SimpleA from 'components/display/SimpleAnchor'
import { ParagraphXs } from 'components/display/Typography'

const Terms = () => (
  <>
    <ParagraphXs weight="400" styleLink>
      By signing up, you confirm that you accept the{' '}
      <a href="/terms" target="_blank">
        Terms of Service
      </a>{' '}
      and{' '}
      <a href="/privacy" target="_blank">
        Privacy Policy
      </a>
      .
    </ParagraphXs>
    <ParagraphXs weight="400" styleLink>
      This site is protected by reCAPTCHA and the Google{' '}
      <SimpleA target="_blank" href="https://policies.google.com/privacy">
        Privacy Policy
      </SimpleA>{' '}
      and{' '}
      <SimpleA target="_blank" href="https://policies.google.com/terms">
        Terms of Service
      </SimpleA>{' '}
      apply.
    </ParagraphXs>
  </>
)

export default Terms
